module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }